<div class="recover-username-email-sent">
  <div class="recover-username-email-sent__description">{{ 'login.recovery.username-email-sent.description' | translate }}</div>

  @if (usernameRecoveryCredentials(); as usernameRecoveryCredentials) {
    <div class="recover-username-email-sent__content">
      <div class="recover-username-email-sent__tooltip-wrapper">
        <itc-table-tooltip tooltipPosition="top-left" [tooltipText]="usernameRecoveryCredentials.userEmail">
          <span class="recover-username-email-sent__email">{{ usernameRecoveryCredentials.userEmail }}</span>
        </itc-table-tooltip>
      </div>

      <div class="recover-username-email-sent__tooltip-wrapper">
        <itc-table-tooltip tooltipPosition="top-left" [tooltipText]="usernameRecoveryCredentials.organizationName">
          <span class="recover-username-email-sent__organization-name">{{ usernameRecoveryCredentials.organizationName }}</span>
        </itc-table-tooltip>
      </div>
    </div>
  }
</div>
